//====================================================
//  Function: Select
//====================================================
function fn_components_select() {
  if ($('.js-select').length) {
    
    $('.js-select').each(function(){
      var selectText;
      var selectResult = $(this).closest('.js-select-block').find('.js-select-result')
      var select;
      var inst = $(this);

      select = $(this).select2({
          multiple: true,
          minimumResultsForSearch: Infinity,
          selectionAdapter: $.fn.select2.amd.require("CustomSelectionAdapter"),
          templateSelection: (data) => {
            if (data.selected.length > 1){
              selectText = data.all.prevObject[0].dataset.textMultiple;
            } else {
              selectText = data.all.prevObject[0].dataset.textSingle;
            }
            return `${data.selected.length} ${selectText}`;
          },
          placeholder: function () {
            $(this).data('placeholder')
          },
        })
        .focus(function () {
          $(this).select2('open')
        })

      selectEvents(inst, selectResult, select)
    });
  }

  if ($('.js-select-single').length) {
    $('.js-select-single')
      .select2({
        minimumResultsForSearch: Infinity,
        placeholder: function () {
          $(this).data('placeholder')
        },
      })
      .focus(function () {
        $(this).select2('open')
      })

    selectEvents($('.js-select-single'))
  }
}


$.fn.select2.amd.define("CustomSelectionAdapter", [
  "select2/utils",
  "select2/selection/multiple",
  "select2/selection/placeholder",
  "select2/selection/eventRelay",
  "select2/selection/single",
],
function(Utils, MultipleSelection, Placeholder, EventRelay, SingleSelection) {

  // Decorates MultipleSelection with Placeholder
  let adapter = Utils.Decorate(MultipleSelection, Placeholder);
  // Decorates adapter with EventRelay - ensures events will continue to fire
  // e.g. selected, changed
  adapter = Utils.Decorate(adapter, EventRelay);

  adapter.prototype.render = function() {
    // Use selection-box from SingleSelection adapter
    // This implementation overrides the default implementation
    let $selection = SingleSelection.prototype.render.call(this);
    return $selection;
  };

  adapter.prototype.update = function(data) {
    // copy and modify SingleSelection adapter
    this.clear();

    let $rendered = this.$selection.find('.select2-selection__rendered');
    let noItemsSelected = data.length === 0;
    let formatted = "";

    if (noItemsSelected) {
      formatted = this.options.get("placeholder") || "";
    } else {
      let itemsData = {
        selected: data || [],
        all: this.$element.find("option") || []
      };
      // Pass selected and all items to display method
      // which calls templateSelection
      formatted = this.display(itemsData, $rendered);
    }

    $rendered.empty().append(formatted);
    $rendered.prop('title', formatted);
  };

  return adapter;
});

var searchTemplate = '<input type="text" placeholder="" class="form-input form-input--search js-search-location">';

function selectEvents(element, result = false, select = false) {

  element.on('select2:open', function (e) {
    $(this).closest('.js-placeholder-block').addClass(class_active)
    if (result == false){
      return false;
    }

    if (select.attr('data-type') == 'search' && $('.js-search-location').length == 0){
      $('.select2-dropdown').prepend(searchTemplate);
      $('.js-search-location').focus();
    } else {
      $('.js-search-location').val('');
      $('.js-search-location').focus();
    }
  })

  element.on('select2:select', function (e) {
    $(this).closest('.js-placeholder-block').addClass(class_active)
    
    if (result == false){
      return false;
    }

    var resultItem = '<li class="select-result-item js-select-result-item" data-id="' + e.params.data.id + '"><span class="select-result-content"><span class="select-result-text">' + e.params.data.text + '</span><span class="select-result-icon icon icon-close js-select-result-remove"></span></span></li>'
    result.append(resultItem);
    element.trigger("change");
  })

  element.on('select2:unselect', function (e) {
    if (result == false){
      return false;
    }
    result.find('.select-result-item[data-id="' + e.params.data.id + '"]').remove(); 
  })

  element.on('select2:close', function (e) {
    if (!$(this).val().length) {
      $(this).closest('.js-placeholder-block').removeClass(class_active)
    }
  })

  $(document).on('click', '.js-select-result-remove', function (event) {
    if (result == false){
      return false;
    }
    var inst = $(this);
    var resultItem = inst.closest('.js-select-result-item');
    var resultItemId = resultItem.data('id');
    $(select).find('option[value="' + resultItemId + '"]').prop('selected', false).trigger("change");
    resultItem.remove();

    if($(select).val().length === 0){
      $(select).closest('.js-placeholder-block').removeClass(class_active)
    }
  })

  $(document).on('keyup', '.js-search-location', function (event) {
    if (result == false){
      return false;
    }
    var input, filter, ul, li, a, i;
    input = document.querySelector('.js-search-location');
    filter = input.value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
    div = document.querySelector(".select2-results__options");
    a = div.getElementsByTagName("li");
    for (i = 0; i < a.length; i++) {
      txtValue = a[i].textContent || a[i].innerText;
      if (txtValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().indexOf(filter) > -1) {
        a[i].style.display = "";
      } else {
        a[i].style.display = "none";
      }
    }
    $(select).resize();
  })
}
